import React, { useState } from "react";
import "../style/QASection.scss";

const questions = [
  "What is the difference between web design and web development? Can I hire you for just one?",
  "What platforms do you specialize in?",
  "Do you build e-commerce websites? If so, what platforms do you use?",
  "Do you offer ongoing maintenance and support after launch?",
  "How long does it typically take to build a website?",
  "What factors affect the cost of a website?"
];

const QASection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="qa-section">
      <h2 className="qa-title">Q&A</h2>
      <p className="qa-subtitle">Browse Through Our Q&A Section To Find Solutions To Common Queries, Or Reach Out To Us Directly For Personalized Support.</p>
      <div className="qa-list">
        {questions.map((question, index) => (
          <div key={index} className="qa-item">
            <button className="qa-question" onClick={() => toggleAnswer(index)}>
              {question} <span>{openIndex === index ? "▲" : "▼"}</span>
            </button>
            {openIndex === index && (
              <div className="qa-answer">
                {index === 0 && (
                  <p>
                    Web design focuses on the visual elements of a website (layout, color, typography), while web development involves coding and building the website's functionality. Yes, you can hire us for either design or development.
                  </p>
                )}
                {index === 1 && (
                  <p>
                    We specialize in WordPress, Shopify, React, and custom development, among others.
                  </p>
                )}
                {index === 2 && (
                  <p>
                    Yes, we build e-commerce websites. We work with platforms like Shopify, WooCommerce, and custom solutions to meet your needs.
                  </p>
                )}
                {index === 3 && (
                  <p>
                    Yes, we offer ongoing support and maintenance services to ensure your website runs smoothly after launch.
                  </p>
                )}
                {index === 4 && (
                  <p>
                    The time it takes to build a website depends on its complexity. Typically, it takes between 4 to 12 weeks.
                  </p>
                )}
                {index === 5 && (
                  <p>
                    Factors that affect the cost include design complexity, development requirements, features, platform choice, and content creation.
                  </p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QASection;
